export const loadJs = (url) => {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = true;
  script.src = url;
  document.head.appendChild(script);
};
